/** The copyright line, shared by the page footer and the portal sidebar.
 * The running release is appended when `showRelease` is set, and is the
 * hover title otherwise. */
export default function CopyrightNotice({
  className,
  showRelease = true,
}: {
  className?: string;
  showRelease?: boolean;
}) {
  return (
    <small
      className={className}
      title={showRelease ? undefined : `Version ${__RELEASE__}`}
    >
      &copy; {new Date().getFullYear()} After Services, Inc.
      {showRelease && <> · {__RELEASE__}</>}
    </small>
  );
}
